import { TabStyles } from '@tableau/widgets';

import { divWithStyle } from '../../../style';
import { buttonContainerDiv, helpTextDiv } from './ExternalContentActionsStyles';

export const REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID: string = 'remove-external-content-dialog';

export const HelpTextDiv = helpTextDiv(REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID);

export const ButtonContainerDiv = buttonContainerDiv(REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID);

export const SpinnerDiv = divWithStyle(REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID, '-spinner', {
  marginTop: TabStyles.Spacing.SmallSpace!
});

export const RemoveBodyDiv = divWithStyle(REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID, '-body', {
  paddingBottom: TabStyles.Spacing.LargeSpace!
});
